

const development = {
    wsui: '/mock',
};
const rd = {
    wsui: '/',
};
const test = {
    wsui: '/',
};

const production = {
    wsui: '/',
};

export interface BaseURL{
    wsui: string;
}

function getBaseUrl(env: string | undefined): BaseURL {
    const map = new Map();
    map.set('dev', development);
    map.set('rd', rd);
    map.set('test', test);
    map.set('production', production);

    const obj: BaseURL = map.get(env);
    return obj;
}

const baseUrl = getBaseUrl(process.env.PROXY_ENV);
export default baseUrl;
